import Button from "@/common/elements/Button";
import { forwardRef, useEffect, useState } from "react";
import MedicalQuestionnaireModal from "./MedicalQuestionnaireModal";
import {
  MedicalInfoContainer,
  QuestionnaireItem,
  QuestionnairesContainer,
} from "./styles";
import { v4 as uuidV4 } from "uuid";
import { medical_questions } from "@/util/medical_questions";
import { useDispatch, useSelector } from "react-redux";
import { setBookings } from "@/slices/bookingsSlice";
import {
  checkGlobalClientParams,
  isNonEmptyVariable,
} from "@/util/common_function";
import dayjs, { isDayjs } from "dayjs";
import API_ENDPOINTS from "@/util/api";
import api from "@/services/axios_custom";
import { MODULES_LIST } from "@/util/common_variable";

const MedicalInfo = forwardRef(() => {
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const globalClientParam = useSelector((state) => state?.clientParams?.list);
  const dispatch = useDispatch();
  const [isModalShown, setIsModalShown] = useState(false);
  const [questionnaire, setQuestionnaire] = useState(null);
  const [medicalQuestionnaires, setMedicalQuestionnaires] = useState([]);
  const [singleMedicalQuestionnaire, setSingleMedicalQuestionnaire] =
    useState(null);
  const [isEdit, setisEdit] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [questionnaireList, setQuestionnaireList] = useState([]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userDetails"));
    if (isNonEmptyVariable(user)) {
      setUserDetails(user);
    }
  }, []);

  useEffect(() => {
    if (globalClientParam?.length) {
      getQuestionnaireListFromAPI();
    }
  }, [globalClientParam]);

  useEffect(() => {
    if (bookings !== null) {
      let medicalQuestionnairesCopy = bookings?.medicalQuestionnaires || [];
      medicalQuestionnairesCopy = medicalQuestionnairesCopy?.map((i) => {
        return {
          ...i,
          totalPoints: i?.questionnaireInstances?.[0]?.totalPoints,
          uuid: uuidV4(),
        };
      });
      setMedicalQuestionnaires(() => medicalQuestionnairesCopy);
    }
  }, [bookings]);

  const asyncFilter = async (array, asyncPredicate) => {
    const results = await Promise.all(array.map(asyncPredicate));
    return array.filter((_, index) => results[index]);
  };

  const getQuestionnaireListFromAPI = async () => {
    try {
      const url = API_ENDPOINTS.config.questionnaire.questionnairesList;
      const { data } = await api.get(url);
      if (data?.length) {
        //Before
        // ndMedicalQuestionnaire:Medical Questionnaire&ndMentalHealth:New Mental Health
        // Afer
        // ["ndMedicalQuestionnaire:Medical Questionnaire","ndMentalHealth:New Mental Health"];

        let bookingIntakeQuestionnaires =
          globalClientParam
            ?.find((param) => param.paramContext === "Intake Medical Buttons")
            ?.paramValue?.split("&") || [];

        // [{key: "ndMedicalQuestionnaire", value: "Medical Questionnaire"}, {key: "ndMentalHealth", value: "New Mental Health"}]
        bookingIntakeQuestionnaires = bookingIntakeQuestionnaires?.map(
          (item) => {
            const [key, value] = item.split(":");
            return { key: key?.trim(), value: value?.trim() };
          }
        );

        const filtered = await asyncFilter(data, async (d) => {
          await new Promise((res) => setTimeout(res, 0));
          return (
            bookingIntakeQuestionnaires?.findIndex(
              (cp) => cp?.value === d?.questionnaireName
            ) !== -1
          );
        });
        console.log("🚀 ~ getQuestionnaireListFromAPI ~ filtered:", filtered);

        setQuestionnaireList(() => filtered);
      }
    } catch (error) {
      console.log(error);

      setQuestionnaireList(() => []);
    }
  };

  const onModalHide = () => {
    setIsModalShown(() => false);
  };

  const onModalShow = () => {
    setIsModalShown(() => true);
  };

  const onAppraisalQuestionnaireClick = (questionnaireID) => {
    questionnaireList?.find((question) => {
      if (question?.questionnaireID === questionnaireID) {
        setQuestionnaire(question);
        if (medicalQuestionnaires?.length) {
          let alreadyResponse = medicalQuestionnaires?.find(
            (mq) =>
              mq?.questionnaireInstances?.[0]?.questionnaireId ==
              questionnaireID
          );

          alreadyResponse = {
            ...alreadyResponse,
            questionnaireInstances:
              alreadyResponse?.questionnaireInstances?.map((item) => {
                return {
                  ...item,
                  questionAnswers: item?.questionAnswers?.map((qa) => {
                    if (
                      isNonEmptyVariable(qa?.answer) &&
                      isValidDateRegex(qa?.answer)
                    ) {
                      return {
                        ...qa,
                        answer: dayjs(qa?.answer),
                      };
                    } else {
                      return qa;
                    }
                  }),
                };
              }),
          };
          console.log("alreadyResponse", alreadyResponse);

          if (
            isNonEmptyVariable(alreadyResponse) &&
            isNonEmptyVariable(alreadyResponse?.questionnaireInstances)
          ) {
            setisEdit(true);
            setSingleMedicalQuestionnaire(() => alreadyResponse);
          } else {
            setisEdit(false);
          }
        } else {
          setisEdit(false);
        }
      }
    });

    onModalShow();
  };

  function isValidDateRegex(dateString) {
    const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
    return regex.test(dateString);
  }
  // const getAnswer = (result) => {
  //   let copyMedicalData = JSON.parse(JSON.stringify(medicalData));

  //   const idx = copyMedicalData?.findIndex(
  //     (m) => m?.questionnaireID === result?.questionnaireID
  //   );

  //   if (idx !== -1) {
  //     copyMedicalData[idx] = {
  //       ...copyMedicalData[idx],
  //       ...result,
  //     };
  //   } else {
  //     copyMedicalData.push(result);
  //   }

  //   dispatch(
  //     setBookings({
  //       medicalQuestionnaires: copyMedicalData,
  //     })
  //   );
  // };

  const getAnswer = (result) => {
    let medicalQuestions = medicalQuestionnaires;
    if (isNonEmptyVariable(result)) {
      result = {
        ...result,
        questionAnswers: result?.questionAnswers?.map((q) => {
          if (isDayjs(q.answer)) {
            q.answer = dayjs(q.answer)?.format("MM/DD/YYYY");
          }

          return q;
        }),
      };
    }
    const medical = {
      bookingID: bookings?.bookingId || null,
      creatorStaffID: userDetails?.staffId,
      questionnaireInstanceId: result?.questionnaireID,
      questionnaireInstances: [result],
    };

    if (isEdit) {
      medicalQuestions = medicalQuestions?.map((cq) => {
        if (cq?.uuid === singleMedicalQuestionnaire?.uuid) {
          return medical;
        }
        return cq;
      });
    } else {
      medicalQuestions.push(medical);
    }

    dispatch(
      setBookings({
        medicalQuestionnaires: medicalQuestions,
      })
    );
    onModalHide();
  };

  return (
    <>
      {isModalShown && (
        <MedicalQuestionnaireModal
          show={isModalShown}
          onHide={onModalHide}
          questionnaire={questionnaire}
          getAnswer={getAnswer}
          singleQuestionnaire={singleMedicalQuestionnaire}
          isEdit={isEdit}
        />
      )}

      <MedicalInfoContainer>
        <h4>Available Questionnaire</h4>
        <QuestionnairesContainer>
          {questionnaireList.map((question, index) => {
            return (
              <QuestionnaireItem key={index} className="col-lg-8">
                <Button
                  onClick={() =>
                    onAppraisalQuestionnaireClick(question?.questionnaireID)
                  }
                  disabled={!bookingsFieldsEnabled}
                >
                  {question?.questionnaireName}
                </Button>
                {/* <div className="last-done">01/02/24 @ 12:25 AM</div> */}
              </QuestionnaireItem>
            );
          })}
        </QuestionnairesContainer>
      </MedicalInfoContainer>
    </>
  );
});

export default MedicalInfo;
